/** Flag tips and chimneys per building, GENERATED by
 *  TOWNS/tools/gen_anchors.py from the shipped sprites. Do not edit. */

export interface TownAnchor {
  /** x of the art's highest point, as a fraction of its width. */
  readonly tip: number;
  /** height / width of the sprite. */
  readonly ratio: number;
  /** (x, y) fractions of the chimney top, for the buildings that smoke. */
  readonly chimney: readonly [number, number] | null;
}

export const TOWN_ANCHORS: Readonly<Record<string, TownAnchor>> = Object.freeze({
  "blackwater_blacksmith": { tip: 0.47, ratio: 0.99, chimney: [0.667, 0.058] },
  "blackwater_capitol": { tip: 0.602, ratio: 1.153, chimney: null },
  "blackwater_castle": { tip: 0.865, ratio: 0.526, chimney: null },
  "blackwater_citadel": { tip: 0.31, ratio: 0.943, chimney: null },
  "blackwater_city_hall": { tip: 0.338, ratio: 0.911, chimney: null },
  "blackwater_fort": { tip: 0.217, ratio: 0.84, chimney: null },
  "blackwater_grail": { tip: 0.525, ratio: 1.854, chimney: null },
  "blackwater_tavern": { tip: 0.567, ratio: 0.871, chimney: [0.816, 0.02] },
  "blackwater_town_hall": { tip: 0.738, ratio: 0.915, chimney: null },
  "blackwater_village_hall": { tip: 0.328, ratio: 0.723, chimney: null },
  "frostmark_blacksmith": { tip: 0.677, ratio: 0.772, chimney: [0.683, 0.006] },
  "frostmark_capitol": { tip: 0.415, ratio: 0.798, chimney: null },
  "frostmark_castle": { tip: 0.525, ratio: 0.525, chimney: null },
  "frostmark_citadel": { tip: 0.407, ratio: 0.918, chimney: null },
  "frostmark_city_hall": { tip: 0.36, ratio: 0.835, chimney: null },
  "frostmark_fort": { tip: 0.668, ratio: 0.72, chimney: null },
  "frostmark_grail": { tip: 0.518, ratio: 1.315, chimney: null },
  "frostmark_tavern": { tip: 0.757, ratio: 0.856, chimney: [0.757, 0.0] },
  "frostmark_town_hall": { tip: 0.812, ratio: 0.818, chimney: null },
  "frostmark_village_hall": { tip: 0.559, ratio: 0.686, chimney: null },
  "sunspire_blacksmith": { tip: 0.293, ratio: 0.779, chimney: [0.667, 0.12] },
  "sunspire_capitol": { tip: 0.681, ratio: 0.933, chimney: null },
  "sunspire_castle": { tip: 0.474, ratio: 0.614, chimney: null },
  "sunspire_citadel": { tip: 0.262, ratio: 0.998, chimney: null },
  "sunspire_city_hall": { tip: 0.326, ratio: 0.888, chimney: null },
  "sunspire_fort": { tip: 0.839, ratio: 0.609, chimney: null },
  "sunspire_grail": { tip: 0.505, ratio: 1.483, chimney: null },
  "sunspire_tavern": { tip: 0.307, ratio: 1.079, chimney: [0.758, 0.03] },
  "sunspire_town_hall": { tip: 0.408, ratio: 1.107, chimney: null },
  "sunspire_village_hall": { tip: 0.801, ratio: 0.906, chimney: null },
  "prismgate_blacksmith": { tip: 0.326, ratio: 0.871, chimney: [0.667, 0.038] },
  "prismgate_capitol": { tip: 0.516, ratio: 0.893, chimney: null },
  "prismgate_castle": { tip: 0.472, ratio: 0.605, chimney: null },
  "prismgate_citadel": { tip: 0.27, ratio: 0.901, chimney: null },
  "prismgate_city_hall": { tip: 0.343, ratio: 0.78, chimney: null },
  "prismgate_fort": { tip: 0.581, ratio: 0.756, chimney: null },
  "prismgate_grail": { tip: 0.483, ratio: 1.322, chimney: null },
  "prismgate_tavern": { tip: 0.682, ratio: 1.031, chimney: [0.682, 0.0] },
  "prismgate_town_hall": { tip: 0.327, ratio: 1.05, chimney: null },
  "prismgate_village_hall": { tip: 0.78, ratio: 0.874, chimney: null },
  "saltreach_blacksmith": { tip: 0.691, ratio: 0.932, chimney: [0.734, 0.005] },
  "saltreach_capitol": { tip: 0.449, ratio: 1.008, chimney: null },
  "saltreach_castle": { tip: 0.67, ratio: 0.595, chimney: null },
  "saltreach_citadel": { tip: 0.863, ratio: 0.78, chimney: null },
  "saltreach_city_hall": { tip: 0.293, ratio: 0.882, chimney: null },
  "saltreach_fort": { tip: 0.485, ratio: 0.595, chimney: null },
  "saltreach_grail": { tip: 0.643, ratio: 1.753, chimney: null },
  "saltreach_tavern": { tip: 0.558, ratio: 1.013, chimney: [0.798, 0.146] },
  "saltreach_town_hall": { tip: 0.411, ratio: 0.932, chimney: null },
  "saltreach_village_hall": { tip: 0.508, ratio: 0.981, chimney: null },
  "deepvault_blacksmith": { tip: 0.31, ratio: 0.638, chimney: [0.67, 0.022] },
  "deepvault_capitol": { tip: 0.472, ratio: 0.553, chimney: null },
  "deepvault_castle": { tip: 0.582, ratio: 0.612, chimney: null },
  "deepvault_citadel": { tip: 0.435, ratio: 0.895, chimney: null },
  "deepvault_city_hall": { tip: 0.27, ratio: 0.851, chimney: null },
  "deepvault_fort": { tip: 0.726, ratio: 0.817, chimney: null },
  "deepvault_grail": { tip: 0.359, ratio: 1.319, chimney: null },
  "deepvault_tavern": { tip: 0.697, ratio: 0.923, chimney: [0.703, 0.0] },
  "deepvault_town_hall": { tip: 0.743, ratio: 1.089, chimney: null },
  "deepvault_village_hall": { tip: 0.374, ratio: 0.855, chimney: null },
  "cogworks_blacksmith": { tip: 0.783, ratio: 0.805, chimney: [0.79, 0.0] },
  "cogworks_capitol": { tip: 0.707, ratio: 0.975, chimney: null },
  "cogworks_castle": { tip: 0.469, ratio: 0.658, chimney: null },
  "cogworks_citadel": { tip: 0.661, ratio: 0.867, chimney: null },
  "cogworks_city_hall": { tip: 0.365, ratio: 0.877, chimney: null },
  "cogworks_fort": { tip: 0.733, ratio: 0.768, chimney: null },
  "cogworks_grail": { tip: 0.521, ratio: 1.621, chimney: null },
  "cogworks_tavern": { tip: 0.773, ratio: 0.837, chimney: [0.778, 0.0] },
  "cogworks_town_hall": { tip: 0.436, ratio: 0.995, chimney: null },
  "cogworks_village_hall": { tip: 0.788, ratio: 0.719, chimney: null },
  "fenmire_blacksmith": { tip: 0.639, ratio: 0.795, chimney: [0.663, 0.012] },
  "fenmire_capitol": { tip: 0.427, ratio: 0.841, chimney: null },
  "fenmire_castle": { tip: 0.52, ratio: 0.528, chimney: null },
  "fenmire_citadel": { tip: 0.269, ratio: 0.827, chimney: null },
  "fenmire_city_hall": { tip: 0.327, ratio: 0.897, chimney: null },
  "fenmire_fort": { tip: 0.825, ratio: 0.745, chimney: null },
  "fenmire_grail": { tip: 0.308, ratio: 1.018, chimney: null },
  "fenmire_tavern": { tip: 0.305, ratio: 0.895, chimney: [0.752, 0.102] },
  "fenmire_town_hall": { tip: 0.692, ratio: 0.874, chimney: null },
  "fenmire_village_hall": { tip: 0.481, ratio: 0.841, chimney: null },
  "emberpit_blacksmith": { tip: 0.508, ratio: 0.87, chimney: [0.767, 0.024] },
  "emberpit_capitol": { tip: 0.54, ratio: 0.942, chimney: null },
  "emberpit_castle": { tip: 0.687, ratio: 0.633, chimney: null },
  "emberpit_citadel": { tip: 0.478, ratio: 0.844, chimney: null },
  "emberpit_city_hall": { tip: 0.378, ratio: 0.852, chimney: null },
  "emberpit_fort": { tip: 0.554, ratio: 0.574, chimney: null },
  "emberpit_grail": { tip: 0.399, ratio: 0.809, chimney: null },
  "emberpit_tavern": { tip: 0.664, ratio: 0.899, chimney: [0.671, 0.0] },
  "emberpit_town_hall": { tip: 0.595, ratio: 1.011, chimney: null },
  "emberpit_village_hall": { tip: 0.751, ratio: 0.915, chimney: null },
  "gravewatch_blacksmith": { tip: 0.631, ratio: 0.867, chimney: [0.671, 0.005] },
  "gravewatch_capitol": { tip: 0.413, ratio: 1.042, chimney: null },
  "gravewatch_castle": { tip: 0.58, ratio: 0.585, chimney: null },
  "gravewatch_citadel": { tip: 0.327, ratio: 0.908, chimney: null },
  "gravewatch_city_hall": { tip: 0.297, ratio: 0.958, chimney: null },
  "gravewatch_fort": { tip: 0.733, ratio: 0.881, chimney: null },
  "gravewatch_grail": { tip: 0.5, ratio: 0.978, chimney: null },
  "gravewatch_tavern": { tip: 0.711, ratio: 0.978, chimney: [0.713, 0.0] },
  "gravewatch_town_hall": { tip: 0.519, ratio: 1.019, chimney: null },
  "gravewatch_village_hall": { tip: 0.467, ratio: 0.873, chimney: null },
  "greenmantle_blacksmith": { tip: 0.257, ratio: 0.67, chimney: [0.667, 0.068] },
  "greenmantle_capitol": { tip: 0.321, ratio: 0.9, chimney: null },
  "greenmantle_castle": { tip: 0.883, ratio: 0.558, chimney: null },
  "greenmantle_citadel": { tip: 0.298, ratio: 0.8, chimney: null },
  "greenmantle_city_hall": { tip: 0.308, ratio: 0.701, chimney: null },
  "greenmantle_fort": { tip: 0.826, ratio: 0.674, chimney: null },
  "greenmantle_grail": { tip: 0.49, ratio: 1.809, chimney: null },
  "greenmantle_tavern": { tip: 0.282, ratio: 0.868, chimney: [0.72, 0.163] },
  "greenmantle_town_hall": { tip: 0.312, ratio: 1.05, chimney: null },
  "greenmantle_village_hall": { tip: 0.357, ratio: 0.873, chimney: null },
  "ironhorde_blacksmith": { tip: 0.469, ratio: 0.617, chimney: [0.663, 0.008] },
  "ironhorde_capitol": { tip: 0.312, ratio: 0.873, chimney: null },
  "ironhorde_castle": { tip: 0.617, ratio: 0.576, chimney: null },
  "ironhorde_citadel": { tip: 0.271, ratio: 0.813, chimney: null },
  "ironhorde_city_hall": { tip: 0.368, ratio: 0.869, chimney: null },
  "ironhorde_fort": { tip: 0.756, ratio: 0.907, chimney: null },
  "ironhorde_grail": { tip: 0.705, ratio: 1.476, chimney: null },
  "ironhorde_tavern": { tip: 0.256, ratio: 0.769, chimney: [0.669, 0.161] },
  "ironhorde_town_hall": { tip: 0.735, ratio: 0.97, chimney: null },
  "ironhorde_village_hall": { tip: 0.416, ratio: 0.858, chimney: null },
  "skyreach_blacksmith": { tip: 0.502, ratio: 0.814, chimney: [0.676, 0.064] },
  "skyreach_capitol": { tip: 0.492, ratio: 0.968, chimney: null },
  "skyreach_castle": { tip: 0.504, ratio: 0.666, chimney: null },
  "skyreach_citadel": { tip: 0.719, ratio: 1.0, chimney: null },
  "skyreach_city_hall": { tip: 0.411, ratio: 0.868, chimney: null },
  "skyreach_fort": { tip: 0.65, ratio: 0.962, chimney: null },
  "skyreach_grail": { tip: 0.446, ratio: 1.257, chimney: null },
  "skyreach_tavern": { tip: 0.391, ratio: 1.169, chimney: [0.727, 0.167] },
  "skyreach_town_hall": { tip: 0.524, ratio: 0.968, chimney: null },
  "skyreach_village_hall": { tip: 0.336, ratio: 0.905, chimney: null },
});
